import { cn } from '@/utils';
import React from 'react';

export default function Badge({
  children,
  className,
  size = 'md',
  ...props
}: {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const sizeClass = {
    sm: 'p-0.5 py-0 text-[9px] font-bold tracking-tightest',
    md: 'px-1 py-0.5 text-sm',
    lg: 'px-1.5 py-1 ',
  }[size];

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded bg-brand font-semibold uppercase text-brand-dark-100 dark:bg-brand-dark',
        sizeClass,
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
